import React, {Component} from 'react';
import {Row, Card, CardTitle, Form, Label, Input} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import LoaderButton from '../../components/LoaderButton';
import {Colxx} from '../../components/common/CustomBootstrap';
import {Form as FinalForm, Field} from 'react-final-form';
import {setGoogleAuthStatus} from "../../redux/authUser/actions";
import {withTranslation} from 'react-i18next';
import {store} from "../../AppRenderer";
import {connect} from 'react-redux';
import Api from '../../services/Api';

class Login extends Component {
  onUserLogin = async (values) => {
    const {history} = this.props;
    try {
      await Api.passwordGrant({
        ...values,
        scope: ["ALL"],
      });
      store.dispatch(setGoogleAuthStatus({
        registered: true,
        enabled: true,
      }));
      history.replace("/dashboard");
    } catch (e) {
      await this.authRoutingHub(e, values);
      return null;
    }
  };

  authRoutingHub = async (e, loginValues) => {
    const {history, googleAuthStatus} = this.props;
    try {
      if (e.response && e.response.data) {
        const {code} = e.response.data;
        if (code === "GOOGLE_AUTH_TOKEN_REQUIRED") {
          await Api.passwordGrant({
            ...loginValues,
            scope: ["GOOGLE_AUTH", "OTT"],
          });
          let status = googleAuthStatus;
          if (!status) {
            status = await this.getGoogleAuthStatus();
          }
          if (status.enabled) {
            if (!status.registered) {
              history.push("/user/security", {
                loginValues,
              });
              return;
            }
            if (status.registered) {
              history.push("/user/googleAuth", {
                loginValues,
              });
              return;
            }
          }
          history.replace("/dashboard");
        }
      }
    } catch (e) {}
  };

  getGoogleAuthStatus = async () => {
    try {
      const {data} = await Api.invoke(
        "GET",
        "/v2/admin-ui/googleAuth/status",
        null,
        null,
      );
      this.props.setGoogleAuthStatus(data);
      return data;
    } catch (e) {
      await Api.logOut();
    }
  }

  render() {
    const {t} = this.props;
    return (
      <FinalForm
        onSubmit={this.onUserLogin}
        render={({handleSubmit, pristine, submitting}) => (
           <Row className="h-100">
             <Colxx xxs="12" md="10" className="mx-auto my-auto">
               <Card className="auth-card">
                 <div className="position-relative image-side ">
                   <p className="text-white h2">
                     {t('Login Page')}
                   </p>
                 </div>
                 <div className="form-side">
                   <NavLink to={'/'} className="white">
                     <span className="logo-single"/>
                   </NavLink>
                   <CardTitle className="mb-4">
                     {t('Login')}
                   </CardTitle>
                   <Form onSubmit={handleSubmit}>
                     <Field name="username">
                       {({input}) => (
                         <div>
                           <Label className="form-group has-float-label mb-4">{t('Username')}
                             <Input {...input} type="text" />
                           </Label>
                         </div>
                       )}
                     </Field>
                     <Field name="password">
                       {({input}) => (
                         <div>
                           <Label className="form-group has-float-label mb-4">{t('Password')}
                           <Input {...input} type="password"/>
                           </Label>
                         </div>
                       )}
                     </Field>
                     <div className="d-flex justify-content-between align-items-center">
                       <LoaderButton
                         color="primary"
                         size="lg"
                         loading={submitting}
                         disabled={submitting || pristine}
                         onClick={handleSubmit}
                       >
                        {t('Login')}
                       </LoaderButton>
                     </div>
                   </Form>
                 </div>
               </Card>
             </Colxx>
           </Row>
         )}
      />
    );
  }
}

const mapStateToProps = ({authUser}) => {
  const {googleAuthStatus} = authUser;
  return {googleAuthStatus};
};

const mapActionsToProps = {
  setGoogleAuthStatus,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation()(Login));
